import axios from "axios";

let url = window.location.href.includes("localhost")
  ? "http://localhost:3000/"
  : window.location.href;

const defaultOptions = {
  baseURL: url,
  headers: {
    "Content-Type": "application/json",
  },
};

export default axios.create(defaultOptions);
